import { createSelector } from 'reselect';
import { ReferralState } from 'types';

const selectCache = (state: any) => state.referralsCache;

export const selectedReferral = createSelector(
  selectCache,
  (cache: any) => cache.data?.referral
);

export const selectReferrals = createSelector(
  selectCache,
  (cache: any) => cache.data?.referrals
);

export const selectReferralLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);

export const selectReferralLoader = createSelector(
  selectCache,
  (cache: any) => cache.referralLoader
);

export const loadMoreLoader = createSelector(
  selectCache,
  (cache: any) => cache.loader
);

export const selectReferralSearchFilters = createSelector(
  selectCache,
  (cache: any) => cache.data?.filters
);

export const selectReferralPresetSearchValues = createSelector(
  selectCache,
  (cache: any) => cache.data?.presetSearchValues
);

export const selectForwardReferralExternalId = createSelector(
  selectCache,
  (cache: any) => cache.data?.forwardReferralExternalId
);

export const selectForwardReferralIsListView = createSelector(
  selectCache,
  (cache: any) => cache.data?.forwardIsListView
);

export const selectReprocess = createSelector(
  selectCache,
  (cache: ReferralState) => cache.reprocess
);
